import React, { useEffect, useState } from 'react'
import style from "./style.module.css";
import parentStyle from "../../ListingsListCards/style.module.css"
import { prixFormat } from 'utils/PrixFormat';
import { useDispatch, useSelector } from 'react-redux';
import {
    actions as ListingreducerActions,
    selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";
import api_call_v2 from 'utils/API_CALL/api_call_v2';
import { actions as UserSpaceActions } from "redux/slices/v2/UserSpace";


function index(
    {
        listing,
        t,
        defaultLiked,
        lang
    }:
        {
            listing: any;
            t: any;
            defaultLiked: boolean;
            lang: string;
        }) {
    const [liked, setLiked] = useState(defaultLiked);
    const favListings = useSelector(
        ListingreducerSelectors.favoriteListingsSelactor
    );
    const dispatch = useDispatch();

    const addDeleteFavourite = (listingId: string, token?: string) => {
        if (favListings.includes(listingId)) {
            api_call_v2(undefined, "post", "deleteFavoris", {
                listingId: listingId,
            })
                .then((res) => {
                    dispatch(
                        ListingreducerActions.setFavListing({
                            favListings: favListings.filter((item) => item !== listingId),
                        })
                    );
                })
                .catch((err) => { })
                .finally();
        } else {
            api_call_v2(undefined, "post", "addFavoris", {
                listingId: listingId,
            })
                .then((res) => {
                    dispatch(
                        ListingreducerActions.setFavListing({
                            favListings: [...favListings, listingId],
                        })
                    );
                })
                .catch((err) => { })
                .finally();
        }
    };

    const onFavoriteIconPress = (listingId: string) => {
        const FBIdToken = localStorage.FBIdToken;
        if (FBIdToken) {
            addDeleteFavourite(listingId, FBIdToken);
        } else {
            dispatch(UserSpaceActions.setIsAuthDialogVisible({ data: true }));
        }
    };

    useEffect(() => {
        if (favListings.includes(listing._id)) setLiked(true);
        else setLiked(false);
    }, [favListings]);

    const formatEtage = (etage, type) => {
        if (etage === 0 || etage === "0" || etage === null) {
            return `${t("Rez-de-chaussée")}`;
        }
        if (etage === 1 || etage === "1") {
            if (type == "Villa" || type == "Maison") {
                return `${t("2 étages")}`;
            } else {
                return `${t("1er étage")}`;
            }
        }
        if (parseInt(etage) > 1) {
            if (type == "Villa" || type == "Maison") {
                return `${parseInt(etage)} ${t("étages")}`;
            } else {
                return `${parseInt(etage)}${t("ème étage")}`;
            }
        }
        return `${etage} ${t("étage")}`;
    };

    const TransactionOptions = {
        Vente: { label: t("À vendre"), color: "#FF376E" },
        Location: { label: t("À louer"), color: "#FFDC5A" },
        "Projets Neufs": { label: t("Projets Neufs"), color: "#B748D5" },
        Vendu: { label: t("Vendu"), color: "#2291ff" },
    };

    return (
        <>
            <div className={style.contentSection}>
                <div className={style.priceContainer}>

                    {listing.vendu ? (
                        <span className={style.subtitleNew}>
                            <i
                                className={"fas fa-circle"}
                                style={{
                                    color: TransactionOptions[
                                        listing.transaction_type
                                    ]
                                        ? TransactionOptions[
                                            listing.vendu
                                                ? "Vendu"
                                                : listing.transaction_type
                                        ].color
                                        : "red",
                                    fontSize: "14px",
                                }}
                            />
                            <text>
                                {t(listing.type)}{" "}
                                {listing.vendu
                                    ? listing.date_fr
                                        ? `${listing.transaction_type == "Location"
                                            ? t("loué")
                                            : t("vendu")
                                        } ${lang == "ar"
                                            ? listing.date_ar
                                            : lang == "en" ? listing.date_en : listing.date_fr
                                        }`
                                        : ""
                                    : listing.transaction_type == t("Location")
                                        ? t("à louer")
                                        : t("à vendre")}{" "}
                            </text>
                        </span>
                    ) : (
                        <>
                            {listing.price_cut ? (
                                <div
                                    style={{ display: "flex", alignItems: "center", gap: "8px" }}
                                >
                                    <div className={style.price}>
                                        <b className={style.nouveau} style={{ color: "#FF376E" }}>
                                            {prixFormat(Math.floor(listing.prix))}
                                        </b>
                                        <div className={style.mad} style={{ color: "#FF376E" }}>
                                            {t("DH")}
                                            {listing?.transaction_type === "Location"
                                                ? ` / ${t("mois")}`
                                                : ""}
                                        </div>
                                    </div>
                                    <div className={style.oldPrice}>
                                        <b className={style.nouveau} style={{ color: "#757E83" }}>
                                            {prixFormat(Math.floor(listing.old_price))}{" "}
                                            <s style={{ color: "#757E83" }}>
                                                {t("DH")}
                                                {listing?.transaction_type === "Location"
                                                    ? ` / ${t("mois")}`
                                                    : ""}
                                            </s>
                                        </b>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={style.price}>
                                        <b className={style.nouveau}>
                                            {prixFormat(Math.floor(listing.prix))}
                                        </b>
                                        <div className={style.mad}>
                                            {t("DH")}
                                            {listing?.transaction_type === "Location"
                                                ? ` / ${t("mois")}`
                                                : ""}
                                        </div>
                                    </div>
                                </>
                            )}
                        </>
                    )}

                    {listing.transaction_type === "Projets Neufs" ? (
                        <div className={style.projetNeuf}>{t("Projet Neuf")}</div>
                    ) : null}
                    <span
                        data-tracking="click"
                        data-value="favoris-listing"
                        className={`${parentStyle.likedHeart} ${liked ? style.isFavoriteHeart : ""
                            }`}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onFavoriteIconPress(listing._id);
                        }}
                    >
                        {!liked ? (
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                                <path d="M17.109 3.03585C18.6282 4.50441 18.6864 6.86749 17.2412 8.40424L9.99965 16.1038L2.75911 8.40422C1.3139 6.86747 1.3721 4.50436 2.89129 3.0358C4.58756 1.39606 7.38119 1.5459 8.87977 3.35668L10.0001 4.70998L11.1196 3.35653C12.6181 1.54574 15.4127 1.39612 17.109 3.03585Z" stroke="#3B484F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        ) : (
                            <>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.109 4.03585C18.6282 5.50441 18.6864 7.86749 17.2412 9.40424L9.99965 17.1038L2.75911 9.40422C1.3139 7.86747 1.3721 5.50436 2.89129 4.0358C4.58756 2.39606 7.38119 2.5459 8.87977 4.35668L10.0001 5.70998L11.1196 4.35653C12.6181 2.54574 15.4127 2.39612 17.109 4.03585Z" fill="#FF376E" stroke="#FF376E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" viewBox="0 0 26 23" fill="none">
                                <path d="M13.0005 4.36781C11.7548 2.59854 8.31945 -0.386327 4.46064 1.72954C-0.374797 4.38091 0.14743 10.1878 4.22854 13.698C7.48005 16.4948 13.0097 20.9844 13.0097 20.9844C13.0097 20.9844 18.52 16.4961 21.7715 13.6994C25.8526 10.1892 26.3748 4.3823 21.5394 1.73093C17.6816 -0.384384 14.247 2.59837 13.0005 4.36781Z" fill="black" fill-opacity="0.4" stroke="white" stroke-width="2" stroke-linecap="round"/>
                            </svg> */}
                            </>
                        )}
                    </span>
                </div>
                <div className={style.content}>
                    <div className={`${style.info}`}>
                        {listing.typologie > 0 ? (
                            <>
                                <div className={style.rooms}>
                                    <div className={style.nouveau}>{listing.typologie}</div>
                                    <div className={style.typeBien}>
                                        {listing?.typologie == 1
                                            ? t(" chambre")
                                            : listing?.typologie < 11
                                                ? t(" chambres ")
                                                : t("chambres")}
                                    </div>
                                </div>
                            </>
                        ) : null}
                        {listing.sdb > 0 ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.nouveau}>
                                        {listing.sdb ? listing.sdb : 0}
                                    </div>
                                    <div className={style.typeBien}>
                                        {listing.sdb == 1
                                            ? t(" salle de bain")
                                            : listing.sdb < 11
                                                ? t("salles de bains ")
                                                : t("salles de bains")}
                                    </div>
                                </div>
                            </>
                        ) : null}
                        {listing.surface > 0 ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.nouveau}>{listing.surface}</div>
                                    <div className={style.typeBien}>{t("m²")}</div>
                                </div>
                            </>
                        ) : null}
                        {(listing.surfaceterrain ||
                            listing.terrainSurface) && (
                                listing.type == "Villa" ||
                                listing.type == "Maison" ||
                                listing.type == "Riad"
                            ) ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.nouveau}>
                                        {listing.surfaceterrain || listing.terrainSurface}
                                    </div>
                                    <div className={style.typeBien}>{t("m² de terrain")}</div>
                                </div>
                            </>
                        ) : null}
                        {listing.ascenseur &&
                            listing.type !== "Terrain" &&
                            listing.type !== "Villa" &&
                            listing.type !== "Maison" &&
                            listing.type !== "Riad" ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.typeBien}>{t("Ascenseur")}</div>
                                </div>
                            </>
                        ) : null}
                        {listing.etage &&
                            listing.type !== "Terrain" &&
                            listing.type !== "Villa" &&
                            listing.type !== "Maison" &&
                            listing.type !== "Riad" ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.typeBien}>{t(formatEtage(listing.etage, listing.type))}</div>
                                </div>
                            </>
                        ) : null}
                        {listing.parking ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.typeBien}>{t("Parking")}</div>
                                </div>
                            </>
                        ) : null}
                        {listing.jardin ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.typeBien}>{t("Jardin")}</div>
                                </div>
                            </>
                        ) : null}
                        {listing.balcons &&
                            listing.type !== "Terrain" &&
                            listing.type !== "Villa" &&
                            listing.type !== "Maison" &&
                            listing.type !== "Riad" ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.typeBien}>{t("Balcons")}</div>
                                </div>
                            </>
                        ) : null}
                        {listing.terrasses &&
                            listing.type !== "Terrain" &&
                            listing.type !== "Villa" &&
                            listing.type !== "Maison" &&
                            listing.type !== "Riad" ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.typeBien}>{t("Terrasse Accessible")}</div>
                                </div>
                            </>
                        ) : null}
                        {listing.piscine &&
                            (listing.type == "Villa" ||
                                listing.type == "Maison" ||
                                listing.type == "Riad") ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.typeBien}>{t("Piscine")}</div>
                                </div>
                            </>
                        ) : null}
                        {listing.meublee ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.typeBien}>{t("Meublé")}</div>
                                </div>
                            </>
                        ) : null}

                        {listing.garage &&
                            (listing.type == "Villa" ||
                                listing.type == "Maison" ||
                                listing.type == "Riad") ? (
                            <>
                                <div className={style.bullet2} />
                                <div className={style.rooms}>
                                    <div className={style.typeBien}>{t("Garage")}</div>
                                </div>
                            </>
                        ) : null}
                    </div>
                    <div className={style.address}>
                        <p className={style.locationAdress}>
                            {!listing.vendu ? (
                                <>
                                    {`${t(listing.type)}`}{" "}
                                    {listing.transaction_type === "Location"
                                        ? t("à louer")
                                        : t("à vendre")
                                    }{" "}
                                </>
                            ) : (null)}
                            {listing?.commune == "Bouskoura" ||
                                listing?.commune == "Dar Bouazza"
                                ? t(listing?.commune?.trim())
                                : t(listing?.province?.trim())}{" "}
                            {listing?.quartier ? "-" : ""} {t(listing?.quartier?.trim())}
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default index